import {
  type CreateOrderItemDTO,
  type DiscountDTO,
  type ICartItemDetailSubItem,
  type Option,
  type StorefrontOrderLine
} from 'ecosystem'
import {
  type BuyerVatRates,
  convertMinorUnitToValue,
  priceProductForBuyer,
  roundNumber
} from 'shared-utils'
import { orderLineValueCalculator } from './payment'

// Extracted from ./orders so client components (e.g. CheckoutCart) can import it
// without pulling in ./orders' klarna-utils -> fetching -> credentials chain.
export const parseCartSubItemsToBackendOrderSubItems = (
  cartSingleSubItems: ICartItemDetailSubItem[] | undefined,
  cartDiscountCode: Option<DiscountDTO>,
  vatRate: number,
  // Sub-items must be priced on the same treatment as their parent — a
  // zero-rated order with gross sub-items would bill VAT nobody owes.
  buyerVat?: Option<BuyerVatRates>
): CreateOrderItemDTO[] => {
  return (
    cartSingleSubItems?.map((cartSingleSubItem) => {
      const { qty: quantity = 1, product } = cartSingleSubItem

      const orderLine: StorefrontOrderLine = {
        product,
        quantity,
        ...priceProductForBuyer(product, vatRate, buyerVat),
        services: [],
        subItems: []
      }
      const { totalAmount, unitPrice } = orderLineValueCalculator(orderLine, cartDiscountCode)

      return {
        product,
        quantity,
        subItems: orderLine.subItems,
        vatRate: orderLine.vatRate,
        additionalInfo: '',
        originalUnitPrice: convertMinorUnitToValue(unitPrice),
        productId: product.id,
        services: [],
        // Blended across the line, and rounded, for the same reason the parent
        // lines are — see `parseStoreToBackendOrderLines`.
        unitPrice: roundNumber(convertMinorUnitToValue(totalAmount / quantity), 2)
      }
    }) || []
  )
}
